<script>
  import GeneralSelect from "../../select/GeneralSelect.svelte";
  import Button from "../../button/Button.svelte";
  import {translate} from "../../../i18n/i18next.js";

  export let project
  export let user
  export let onClickAddUser

  $: options = [
    {value: "ProjectAdmin", translationKey: "mySchedule.permissions.projectAdmin.name"},
    project.plan === "auto-mps"
      ? {value: "Planner", text: "計画担当者"}
      : {value: "ResultInput", translationKey: "mySchedule.permissions.resultInput.name"},
    {value: "ReadOnly", translationKey: "mySchedule.permissions.readOnly.name"},
  ]

  let selectedPermission = "ReadOnly"
</script>

<tr
  class="table-row"
>
  <td>{user.name || "-"}</td>
  <td>
    <GeneralSelect
      bind:value={selectedPermission}
      options={options}
      defaultValue="ReadOnly"
    />
  </td>
  <td>
    <Button type="primary" onClick={() => onClickAddUser(user.id, selectedPermission)}>
      {translate("generic.add")}
    </Button>
  </td>
</tr>

<style>
  td {
    border: 0;
    padding: 8px;
    text-align: left;
    min-width: 10px;
  }
</style>
